import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import { E取込分類, E取込形式 } from '@/openapi/enum';
import { 取込Api, 取込ListItemResponse, 部門Api, 部門ListItemResponse } from '@/openapi/user';

import C変換枚数 from '@/components/取込/変換枚数/変換枚数.vue';
import C取込表 from '@/entries/user/pages/authorized/事業所/計画書/取込/表/取込表.vue';
import { RowInfo } from '@/entries/user/pages/authorized/事業所/計画書/取込/表/取込表';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 変換枚数Mixin from '@/entries/user/mixins/変換枚数Mixin';
import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import 取込DialogMixin from '@/entries/user/mixins/取込DialogMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(計画書Mixin, 事業所Mixin, 変換枚数Mixin, 取込Mixin, 取込DialogMixin).extend({
  name: 'P取込',

  components: {
    C変換枚数,
    C取込表,
  },

  data(): {
    e取込形式: typeof E取込形式;
    e取込分類: typeof E取込分類;
    部門s: 部門ListItemResponse[];
    取込s: 取込ListItemResponse[];
    rowInfos: RowInfo[];
    baseUrl: string;
    templateTypes: string[];
  } {
    return {
      e取込形式: E取込形式,
      e取込分類: E取込分類,
      部門s: [],
      取込s: [],
      rowInfos: [],
      baseUrl: process.env.BASE_URL,
      // {実績|三表計画}月次貸借対照表、
      // {実績|三表計画}月次損益計算書_月次製造原価報告書は
      // 月次貸借対照表、月次損益計算書_月次製造原価報告書と同じフォーマットのテンプレートとなる。
      templateTypes: [
        E取込分類[E取込分類.決算書],
        E取込分類[E取込分類.固定資産台帳],
        E取込分類[E取込分類.月次貸借対照表],
        E取込分類[E取込分類.月次損益計算書_月次製造原価報告書],
        E取込分類[E取込分類.三表計画年次貸借対照表],
        E取込分類[E取込分類.三表計画年次損益計算書_三表計画年次製造原価報告書],
      ],
    };
  },

  computed: {
    count試算表Row(): number {
      return this.rowInfos.filter(
        (r) => r.取込分類 === E取込分類.月次貸借対照表 || r.取込分類 === E取込分類.月次損益計算書_月次製造原価報告書
      ).length;
    },
  },

  created(): void {
    this.load();
  },

  methods: {
    async load(): Promise<void> {
      // データ取得
      const responses = await Promise.all([
        UserApiUtility.ogApi(部門Api).list部門(this.事業所.pk),
        UserApiUtility.ogApi(取込Api).list取込(this.計画書.pk),
      ]);
      this.部門s = responses[0].data;
      this.取込s = responses[1].data;

      // 行情報作成
      const createRowInfo = (取込分類: E取込分類, 部門?: 部門ListItemResponse): RowInfo => {
        return {
          取込分類: 取込分類,
          部門: 部門,
        };
      };
      const e取込分類Values = Object.keys(E取込分類).map(Number).filter(Number.isInteger);
      this.rowInfos = e取込分類Values
        .flatMap((v) => {
          switch (v) {
            case E取込分類.決算書:
            case E取込分類.固定資産台帳:
            case E取込分類.月次貸借対照表:
              return createRowInfo(v);
            case E取込分類.月次損益計算書_月次製造原価報告書:
              return this.部門s.map((部) => createRowInfo(v, 部));
            default:
              return;
          }
        })
        .filter((d) => d !== undefined) as RowInfo[];
    },
    async loadPdf(): Promise<void> {
      await this.load変換枚数();
      this.load();
    },
  },
});
